import { render, staticRenderFns } from "./ButtonMaker.vue?vue&type=template&id=7852067e&"
import script from "./ButtonMaker.vue?vue&type=script&lang=js&"
export * from "./ButtonMaker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports